<template>
    <div class="PriceF" dir="rtl">
        <div class="PriceFs">
            <div class="position-relative col-12 p-1 pointer priceFilterBtn" @click="openClosePriceFilter">
                <span class="PriceF-span me-2">محدوده قیمت</span>
            </div>
            <div class="priceFilterList" v-if="openPriceFilter">
                <hr style="height: 0.5px;color: #aaaaaa;" class="my-2">
                <div class="PriceFsChild" dir="ltr">
                  <input
                    type="range"
                    class="w-100 "
                    :step="100000"
                    :min="0"
                    :max="60000000"
                    v-model="value[0]"
                    style="direction: rtl;"
                  />
                  <div class="p-2 text-center">
                      <span class="gray-color-b m-0">از</span>
                      {{toLocaleString(value[0])}}
                      <span class="gray-color-b m-0">تومان</span>
                  </div>
                  <input
                    type="range"
                    class="w-100"
                    :step="100000"
                    :min="0"
                    :max="60000000"
                    v-model="value[1]"
                    style="direction: rtl;"
                  />
                  <div class="p-2 text-center">
                      <span class="gray-color-b m-0">از</span>
                      {{toLocaleString(value[1])}}
                      <span class="gray-color-b m-0">تومان</span>
                  </div>
                </div>
                <button aria-label="اعمال تغییر" class="btn do-filter w-100" @click="doPriceFilter" type="button">اعمال تغییر</button>
            </div>
        </div>
    </div>

</template>
<script>
export default {
  name: 'PriceF',
  data () {
    return {
      openPriceFilter: false,
      priceCheckbox: false,
      value: [0, 50000000]
    }
  },
  methods: {
    toLocaleString: function (x) {
      return parseInt(x).toLocaleString('fa')
    },
    openClosePriceFilter: function () {
      if (!this.openPriceFilter) {
        this.openPriceFilter = true
      } else {
        this.openPriceFilter = false
      }
    },
    doPriceFilter: function () {
      this.addFilter('priceGteLte', this.value)
    }
  },
  mounted () {
    try { this.value = [Number(this.$route.query.priceGteLte.split(',')[0]), Number(this.$route.query.priceGteLte.split(',')[1])] } catch {}
  }
}
</script>
<style src="@vueform/slider/themes/default.css"></style>
<style>
.slider-tooltip{
    background: #e98b78 !important;
    border: 1px solid #e98b78 !important;
}
.slider-connect{
    background: #e98b78 !important;
    height: 2px !important;
}
.slider-base, .slider-connects{
    height: 2px !important;
}
</style>
<style scoped>
.gray-color-b{
    color:#BDBDBD;
    font-weight: 500;
}
.input-price{
    width: 100px;
    border: #BDBDBD 1px solid;
    border-radius: 6px;
}
.oc-icon{
    left: 0;
    color: #aaaaaa;
}
.PriceF-span{
    color: #4c4b4b;
    font-weight: 500;
    font-size: 14px;
}
.PriceFs{
    background: #FFFFFF;
    border: solid 2px #e4e4e4;
    border-radius: 9px;
    padding: 10px;
}
.PriceFsChild{
    margin-bottom:8px;
}
.Price-checkbox{
    position: absolute;
    opacity: 0;
}
.container-checkbox:hover input ~ .PriceF-icon {
    cursor: pointer;
}
.title-Price{
    position: absolute;
    margin: 3px;
}
.checked{
    color: #e98b78;
}
.color-pink{
    color: #b4aaf3;
}
.do-filter{
  background: white;
  border: solid 1px #e98b78;
  transition: 0.4;
}
.do-filter:hover{
  background: #e98b78;
  color: black;
  border: solid 1px #e98b78;
  transition: 0.4s;
}
.do-filter:active{
  background: #e98b78;
  color: black;
  border: solid 1px #e98b78;
}
.do-filter:focus{
  color: black;
  border: solid 1px #e98b78;
}
input[type="range"]{
  accent-color: #e98b78;
}
</style>
